import api from './api';

const invoiceService = {
  // Get all invoices
  getAllInvoices: (params = {}) => {
    return api.get('/api/invoices', { params });
  },

  // Get single invoice
  getInvoice: (id) => {
    return api.get(`/api/invoices/${id}`);
  },

  // Get tenant invoices
  getTenantInvoices: (tenantId) => {
    return api.get(`/api/invoices/tenant/${tenantId}`);
  },

  // Create invoice
  createInvoice: (data) => {
    return api.post('/api/invoices', data);
  },

  // Generate invoice (alias for createInvoice)
  generateInvoice: (data) => {
    return api.post('/api/invoices', data);
  },

  // Generate monthly invoices
  generateMonthlyInvoices: () => {
    return api.post('/api/invoices/generate');
  },

  // Update invoice
  updateInvoice: (id, data) => {
    return api.put(`/api/invoices/${id}`, data);
  },

  // Update invoice status
  updateInvoiceStatus: (id, status) => {
    return api.put(`/api/invoices/${id}/status`, null, {
      params: { status }
    });
  },

  // Send invoice reminders
  sendReminders: () => {
    return api.post('/api/invoices/send-reminders');
  },

  // Get invoice balance
  getInvoiceBalance: (id) => {
    return api.get(`/api/invoices/${id}/balance`);
  },

  // Void an invoice
  voidInvoice: (id, reason) => {
    return api.post(`/api/invoices/${id}/void`, { reason });
  },

  // Apply waiver to an invoice
  applyWaiver: (id, amount, reason) => {
    return api.post(`/api/invoices/${id}/waiver`, { amount, reason });
  },

  // Get overdue invoices
  getOverdueInvoices: () => {
    return api.get('/api/invoices/overdue');
  },

  // Get current tenant's invoices
  getMyInvoices: () => {
    return api.get('/api/invoices/me/invoices');
  },
};

export default invoiceService;
